import { searchCommonConfig } from './common'

/**
 * Fictora 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#1F1E20',
    startReadingBg: 'linear-gradient(90deg, #FF2D89 0%, #FF8AB9 100%)',
  },
}
